export default function IconGantBranch () {
  return (
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 0V6C1 7.10457 1.89543 8 3 8H9" stroke="#D5DCDF"/>
    </svg>
  )
}
